import { render, staticRenderFns } from "./targetcollectiondtl.vue?vue&type=template&id=67eb3b94&scoped=true"
import script from "./targetcollectiondtl.vue?vue&type=script&lang=js"
export * from "./targetcollectiondtl.vue?vue&type=script&lang=js"
import style0 from "./targetcollectiondtl.vue?vue&type=style&index=0&id=67eb3b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb3b94",
  null
  
)

export default component.exports